module.exports = __webpack_public_path__ + "media/starry_awakening.e2a2f6bb.ogg";